import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import ICONS from "../../../../../assets/Icons/index.js";
import CommonToast from "../../../../../components/_utils/CommonToast/index.jsx";
import UniversalRefreshToast from "../../../../../components/_utils/UniversalRefreshToast/index.jsx";
import ScheduleInternalTxnHistroy from "../../../../../components/ScheduleInternalTxn/ScheduleInternalTxnHistory/index.jsx";
import ScheduleTransactionViewAllPopup from "../../../../../components/Transactions/ScheduleBeneTransaction/ScheduleBeneTransactionViewAllPopup/index.jsx";
import {
  beneTxnMultiDeniedApproval,
  beneTxnViewAllAcc,
} from "../../../../../redux/features/beneficiary/beneTxnViewAccData/beneTxnViewAccData";
import { internalTxnMultiRejectApproval } from "../../../../../redux/features/internalTransaction/internalTransactionSingleApproval.js";
import { internalTxnViewAll } from "../../../../../redux/features/internalTransaction/internalTransactionViewAll.js";
import { schedulesInternalTxnReject } from "../../../../../redux/features/scheduleInternalTxn/index.js";
import { schedulesTxnReject } from "../../../../../redux/features/scheduleTransaction/index.js";
import { viewAccountDetail } from "../../../../../redux/features/verifyPAN/verifyPAN.js";
import InternalTransactionViewAll from "../../../../InternalTransactionMain/InternalTransactionViewAll/index.jsx";
import BeneficiaryTransactionViewall from "../../../../Transactions/BeneficiaryTransactions/BeneficiaryTransactionViewall/index.jsx";
import "./RejectingTransactionPopup.css";

const RejectingTransactionPopup = (props) => {
  const [getDeclineReason, setDeclineReason] = useState(props?.declineReason);
  const [loading, setLoading] = useState(true);
  const [pendingTxn, setPendingTxn] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [showLoader, setShowLoader] = useState(false);
  const [showCancleBtn, setShowCancleBtn] = useState(true);
  const services = useSelector((state) => state.refreshToken.services);
  const [sidebarState, setSidebarState] = useState(false);
  const [focus, setFocus] = useState(false);

  const dispatch = useDispatch();
  const navigate = useNavigate();

  const { beneTxnViewAllAccLoading, beneTxnViewAllAccData } = useSelector(
    (state) => state?.beneTxnViewAccData,
  );

  const { internalTxnViewAllAccData, internalTxnViewAllAccLoading } =
    useSelector((state) => state?.internalTxnViewall);

  const { schedulesTxnViewAllData, schedulesTxnViewAllLoading } = useSelector(
    (state) => state?.schedulesTxnSlice,
  );

  const {
    schedulesInternalTxnViewAllData,
    schedulesInternalTxnViewAllLoading,
  } = useSelector((state) => state?.scheduleInternalTxnSlice);

  const { viewAccountDetailData } = useSelector((state) => state.verify);

  const handleCloseInternalReject = () => {
    props?.setRejectTxnPopup(false);
    props?.setHandlePendingAlert("pendingalert");
    props?.setShowPopup(true);
  };

  const handleCloseRejectingPopup = () => {
    props.setShowRejectAllTxnReson(true);
    props.setRejectTxnPopup(false);
    if (props?.type !== "ArchiveAccount") {
      props.setRejectTxnPopup(false);
    }
    // if (props?.type !== "scheduleAcc") {
    //   props.setShowScheduleTxnPopup(false);
    // }
    setShowLoader(true);

    if (props.flow === "edit") {
      props?.setIsDennied(false);
      props?.setIsPending(false);
      props?.setIsApproved(false);
      props?.setIsArchived(false);
      props?.setShutViewAll(false);
    }
  };

  // const handleCloseRejectingPopup = () => {
  //   alert("ddsda");
  //   props.setShowRejectAllTxnReson(true);
  //   props.setRejectTxnPopup(false);
  //   if (props?.type !== "ArchiveAccount") {
  //     props.setRejectTxnPopup(false);
  //   }
  // if (props?.type !== "scheduleAcc") {
  //   props.setShowScheduleTxnPopup(false);
  // }
  //   setShowLoader(true);

  //   if (props.flow === "edit") {
  //     props.setIsDennied(false);
  //     props.setIsPending(false);
  //     props.setIsApproved(false);
  //     props.setIsArchived(false);
  //     props.setShutViewAll(false);
  //   }
  // };

  const handleAlertSchedule = () => {
    props.setShowScheduleTxnPopup(false);
    props.setShowPopup(true);
  };

  const handleRejectScheduleTxn = async () => {
    const AccountIdData = props?.declineReason;
    let id2 =
      !schedulesTxnViewAllLoading &&
      schedulesTxnViewAllData?.transactions?.length > 0
        ? schedulesTxnViewAllData?.transactions.map((data) => data?.txn_id)
        : [];
    if (id2.length > 0) {
      let data2 = await dispatch(
        schedulesTxnReject({
          id: id2,
          reason: props?.declineReason,
          services,
        }),
      );
      if (data2?.payload?.status === false) {
        const error_msg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(data2?.payload?.errors?.base[0]?.errors)
            ? data2.payload.errors.base[0].errors[0]
            : data2?.payload?.errors?.base?.[0] || "Unknown error occurred";

        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowCancleBtn(true);
        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        props.setShowScheduleTxnPopup(false);
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        handleRejectAllTransaction();
        setTimeout(() => {
          props.setShowScheduleTxnPopup(false);
        }, 1000);
        props.handleConfirm(props.accountId, props.declineReason);
        await dispatch(viewAccountDetail({ id: props.accountId }));
      }
    }
  };

  const handleAlertReject = () => {
    props?.setRejectTxnPopup(false);
    props?.setShowPopup(true);
    props?.setPendingTxnAlert(true);
    props?.setHandlePendingAlert("pendingalert");
  };

  const handleAccRejectAlert = () => {
    props?.setRejectTxnPopup(false);
    props?.setShowPopup(true);
  };

  const handleRejectScheduleInternalTxn = async () => {
    const AccountIdData = props?.declineReason;
    let id2 =
      !schedulesInternalTxnViewAllLoading &&
      schedulesInternalTxnViewAllData?.transactions?.length > 0
        ? schedulesInternalTxnViewAllData?.transactions.map(
            (data) => data?.txn_id,
          )
        : [];
    if (id2.length > 0) {
      let data2 = await dispatch(
        schedulesInternalTxnReject({
          type: "scheduleInternalTxn",
          id: id2,
          reason: props?.declineReason,
          services,
        }),
      );
      if (data2?.payload?.status === false) {
        const error_msg2 = data2?.payload?.errors?.user_unauthorized
          ? data2?.payload?.errors?.user_unauthorized[0]
          : Array.isArray(data2?.payload?.errors?.base) &&
              Array.isArray(data2?.payload?.errors?.base[0]?.errors)
            ? data2.payload.errors.base[0].errors[0]
            : data2?.payload?.errors?.base?.[0] || "Unknown error occurred";

        CommonToast({
          text: error_msg2,
          icon: ICONS?.ERROR_WHITE_CIRCLE,
          variant: "var(--error)",
          buttonNeeded: false,
        });
        setShowCancleBtn(true);
        setShowLoader(false);
      } else if (data2?.payload?.status === true) {
        props.setShowScheduleTxnPopup(false);
        CommonToast({
          text: "Scheduled transactions rejected successfully.",
          icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
          variant: "var(--success)",
          btnProps: {
            isDisabled: false,
            enabledTextColor: "var(--text-primary)",
            enabledBgColor: "var(--primary-bg)",
          },
        });

        // handleRejectAllTransaction();
        setTimeout(() => {
          props.setShowScheduleTxnPopup(false);
        }, 1000);
        props.handleInternalAccountreject(props.accountId, props.declineReason);
      }
    }
  };

  const handleRejectAllTransaction = async () => {
    setShowCancleBtn(false);
    setShowLoader(true);

    const AccountIdData = props?.declineReason;
    let id = [];
    let id2 = [];

    if (
      props?.type === "internalAccount" ||
      props?.type === "Internal_Account_Detail" ||
      props?.type === "Internal_AccountApproval" ||
      props?.type === "decline internalAccount details" ||
      props?.type === "decline_internal_account_require_approval_flow"
    ) {
      id =
        !internalTxnViewAllAccLoading &&
        internalTxnViewAllAccData?.transactions?.length > 0
          ? internalTxnViewAllAccData?.transactions.map((data) => data?.txn_id)
          : [];
    } else {
      id =
        !beneTxnViewAllAccLoading &&
        beneTxnViewAllAccData?.transactions?.length > 0
          ? beneTxnViewAllAccData?.transactions.map((data) => data?.txn_id)
          : [];
    }

    UniversalRefreshToast("Rejecting transaction");

    let data = null;
    let data2 = null;

    if (
      props?.type === "internalAccount" ||
      props?.type === "Internal_AccountApproval" ||
      props?.type === "decline internalAccount details" ||
      props?.type === "Internal_Account_Detail" ||
      props?.modal_type === "internal_txn_detail_modal"
    ) {
      data = await dispatch(
        internalTxnMultiRejectApproval({ id, AccountIdData }),
      );
      if (
        data?.payload?.status &&
        schedulesInternalTxnViewAllData?.transactions?.length > 0
      ) {
        props?.setShowScheduleTxnPopup(true);
        props.setRejectTxnPopup(false);
      } else {
        setTimeout(() => {
          props?.handleInternalAccountreject(
            props.accountId,
            props.declineReason,
          );
        }, 500);
      }
    } else {
      if (id.length > 0) {
        data = await dispatch(
          beneTxnMultiDeniedApproval({ id, AccountIdData }),
        );
      } else {
        data = { payload: { status: true } };
      }

      if (
        data?.payload?.status &&
        schedulesTxnViewAllData?.transactions?.length > 0
      ) {
        props?.setShowScheduleTxnPopup(true);
      } else {
        setTimeout(() => {
          props.handleConfirm(props.accountId, props.declineReason);
        }, 500);
      }
    }

    if (data?.payload?.errors?.user_unauthorized?.length > 0) {
      const serviceKey =
        props?.type === "internalAccount" ||
        props?.type === "Internal_AccountApproval" ||
        props?.type === "Internal_Account_Detail"
          ? "AInternalTxn"
          : props?.type === "RejectAllTransactionPopup"
            ? "BAScheduledTxn" || "IAScheduledTxn"
            : "ABeneficiaryTxn";

      navigate("/feature_not_assigned", {
        state: { unavailableService: serviceKey },
      });
      return;
    }

    await new Promise((resolve) => setTimeout(resolve, 2000));

    if (data?.payload?.status === false) {
      const error_msg = data?.payload?.errors?.user_unauthorized
        ? data?.payload?.errors?.user_unauthorized[0]
        : Array.isArray(data?.payload?.errors?.base) &&
            Array.isArray(data?.payload?.errors?.base[0]?.errors)
          ? data.payload.errors.base[0].errors[0]
          : data?.payload?.errors?.base?.[0] || "Unknown error occurred";

      CommonToast({
        text: error_msg,
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setShowCancleBtn(true);
      setShowLoader(false);
    } else if (data?.payload?.status) {
      // if (props.scheduleType !== "accSchedule") {
      //   props?.setAlertDetails((prev) =>
      //     prev.map((item) =>
      //       item.keyId === props?.associatePopupDate?.accId
      //         ? {
      //             ...item,
      //             alertData: { ...item.alertData, pendingTxn: false },
      //           }
      //         : item,
      //     ),
      //   );
      // }
      CommonToast({
        text: "Transaction rejected successfully.",
        icon: ICONS?.SELECTED_WITH_WHITE_FILLED,
        variant: "var(--success)",
        btnProps: {
          isDisabled: false,
          enabledTextColor: "var(--text-primary)",
          enabledBgColor: "var(--primary-bg)",
        },
      });

      // please dont remove this code it required for another flow

      // setTimeout(() => {
      //   if (
      //     (props?.type === "internalAccount" ||
      //       props?.type === "Internal_AccountApproval" ||
      //       props?.type === "Internal_Account_Detail") &&
      //     schedulesInternalTxnViewAllData?.transactions?.length == 0
      //   ) {
      //     alert("end");
      //     props.handleInternalAccountreject(
      //       props.accountId,
      //       props.declineReason,
      //     );
      //   }
      // }, 500);

      setDeclineReason("");

      // setTimeout(() => {
      //   props.handleConfirm(props.accountId, props.declineReason);
      // }, 500);
    } else if (data?.payload === undefined) {
      CommonToast({
        text: "An error occurred while taking action on this account",
        icon: ICONS?.ERROR_WHITE_CIRCLE,
        variant: "var(--error)",
        buttonNeeded: false,
      });
      setTimeout(() => {
        props.setRejectTxnPopup(false);
      }, 1000);
      setDeclineReason("");
    }
  };
  useEffect(() => {
    (async () => {
      await dispatch(viewAccountDetail({ id: props?.accountId }));
    })();
  }, []);
  useEffect(() => {
    const handleKeyDown = (event) => {
      if (event.key === "Enter") {
        if (!showLoader) {
          if (!focus && !sidebarState) {
            props?.type == "ArchiveAccount"
              ? handleCloseRejectingPopup()
              : handleRejectAllTransaction();
          }
        }
      }

      if (event.key === "ArrowUp" || event.key === "ArrowDown") {
        event.preventDefault();
      }
    };

    window.addEventListener("keydown", handleKeyDown);

    return () => {
      window.removeEventListener("keydown", handleKeyDown);
    };
  }, [showLoader, focus, sidebarState]);

  useEffect(() => {
    async function fetchData() {
      try {
        if (currentPage === 1) {
          setLoading(true);
        }

        let response = [];
        if (
          props?.type === "internalAccount" ||
          props?.type === "Internal_AccountApproval" ||
          props?.type === "Internal_Account_Detail"
        ) {
          let queryParams = {
            page_no: 1,
            page_item_count: 50,
            lifecycle_status: "pending",
            internal_account_id: props?.accountId,
          };
          response = await dispatch(internalTxnViewAll(queryParams));
        } else {
          let queryParams = {
            page_no: 1,
            page_item_count: 50,
            lifecycle_status: "pending",
            beneficiary_account_id: props?.accountId,
          };
          response = await dispatch(beneTxnViewAllAcc(queryParams));
        }

        const newData =
          props?.type === "internalAccount" ||
          props?.type === "Internal_AccountApproval" ||
          props?.type === "Internal_Account_Detail"
            ? internalTxnViewAllAccData?.transactions
            : response?.payload?.transactions || [];
        setPendingTxn((prevData) =>
          currentPage === 1 ? newData : [...prevData, ...newData],
        );
        setLoading(false);
      } catch (error) {
        setLoading(false);
        console.error(error);
      }
    }
    fetchData();
  }, [dispatch, currentPage]);

  return (
    <div className="w-full h-full fixed top-top-base left-left-base">
      <div
        className={`RejectAllTxn_pop_div  flex flex-col overflow-hidden Qmd:rounded-border-radius-md z-z-index-modal ${props?.type === "Internal_Account_Detail" ? "h-full-height" : "Qmd:h-popup-height h-h-full-height"}}`}
      >
        <div
          className={`flex-1 w-full overflow-hidden ${props?.type === "Internal_Account_Detail" && "rounded-b-border-radius-md"}`}
        >
          {props?.type === "ArchiveAccount" ||
          props?.type === "decline_account_require_approval_flow" ||
          props?.type === "alertAssociated" ? (
            <>
              <BeneficiaryTransactionViewall
                bene_account_id={props?.accountId}
                typepop={"RejectAllTransactionPopup"}
                flowType={props?.type}
                closeRejectAllTxn={props?.handleClosePopup}
                // bene_account_name={props?.accountName}
                bene_account_name={
                  props?.type === "alertAssociated"
                    ? props?.accountName
                    : props?.accountName
                }
                setRejectTxnPopup={props?.setRejectTxnPopup}
                // handleCloseRejectingPopup={handleCloseRejectingPopup}
                handleRejectAllTransaction={
                  props?.type === "decline_account_require_approval_flow"
                    ? handleRejectAllTransaction
                    : props?.type === "alertAssociated"
                      ? handleAlertReject
                      : handleCloseRejectingPopup
                }
                setShowLoader={setShowLoader}
                setSidebarState={setSidebarState}
                setShowScheduleTxnPopup={props?.setShowScheduleTxnPopup}
                showLoader={showLoader}
                setPendingTxnAlert={props?.setPendingTxnAlert}
                type={"alertAssociated"}
                setFocus={setFocus}
              />
            </>
          ) : (props?.type === "decline account details" ||
              props?.type === "AlertPendingTxn") &&
            window.location.pathname.toLowerCase().includes("beneficiary") ? (
            <>
              <BeneficiaryTransactionViewall
                bene_account_id={props?.accountId}
                typepop={"RejectAllTransactionPopup"}
                flowType={props?.type}
                closeRejectAllTxn={props?.handleClosePopup}
                bene_account_name={
                  viewAccountDetailData?.beneficiary_accounts[0]?.name
                }
                handleRejectAllTransaction={
                  props?.type === "AlertPendingTxn"
                    ? handleAccRejectAlert
                    : handleRejectAllTransaction
                }
                setShowLoader={setShowLoader}
                setSidebarState={setSidebarState}
                setShowScheduleTxnPopup={props?.setShowScheduleTxnPopup}
                // handleCloseRejectingPopup={handleCloseRejectingPopup}
                showLoader={showLoader}
                setFocus={setFocus}
              />
            </>
          ) : props?.type === "internalAccount" ||
            props?.type === "Internal_AccountApproval" ||
            props?.type === "RejectInternalTxn" ? (
            <>
              <InternalTransactionViewAll
                typepop={"RejectAllTransactionPopup"}
                type={props?.type}
                internal_acc_id={props?.accountId}
                bank_acc_no={props?.accountNumber}
                closeRejectAllTxn={props?.handleClosePopup}
                handleRejectAllTransaction={
                  props?.type === "Internal_AccountApproval"
                    ? handleRejectAllTransaction
                    : props?.type === "RejectInternalTxn"
                      ? handleCloseInternalReject
                      : handleCloseRejectingPopup
                }
                setShowLoader={setShowLoader}
                setSidebarState={setSidebarState}
                setFocus={setFocus}
              />
            </>
          ) : props?.type === "scheduleAcc" ? (
            <>
              <ScheduleTransactionViewAllPopup
                closeCallback={props?.handleClosePopup}
                title={"Associated schedules found"}
                subtitle={
                  "The following schedules are linked and need to be rejected before rejecting this account."
                }
                type="scheduleAcc"
                setShowScheduleTxnPopup={props?.setShowScheduleTxnPopup}
                payload={{
                  typepop: "RejectAllTransactionPopup",
                  schedule_acc_id: props?.accountId,
                  bank_acc_no: props?.accountNumber,
                  number: "swadfsafs",

                  schedule_acc_name: props?.accountName,
                  handleRejectAllTransaction: props.associateschedule
                    ? handleAlertSchedule
                    : handleRejectScheduleTxn,
                  // : handleCloseRejectingPopup,
                }}
              />
            </>
          ) : props?.type === "scheduleInternalAcc" ? (
            <>
              <ScheduleInternalTxnHistroy
                onClose={props?.handleClosePopup}
                title={"Associated schedules found"}
                subtitle={
                  "The following schedules are linked and need to be rejected before rejecting this account."
                }
                type="scheduleInternalAcc"
                setShowScheduleTxnPopup={props?.setShowScheduleTxnPopup}
                internal_account_id={props?.accountId}
                destination_account_number={props?.accountNumber}
                payload={{
                  typepop: "RejectAllTransactionPopup",
                  schedule_acc_id: props?.accountId,
                  bank_acc_no: props?.accountNumber,
                  number: "swadfsafs",

                  handleRejectAllTransaction: handleRejectScheduleInternalTxn,
                  // : handleCloseRejectingPopup,
                }}
              />
            </>
          ) : props?.type === "decline internalAccount details" ||
            props?.type === "Internal_Account_Detail" ||
            (props?.type === "decline account details" &&
              window.location.pathname.includes("internal")) ? (
            <>
              <InternalTransactionViewAll
                typepop={"RejectAllTransactionPopup"}
                internal_acc_id={props?.accountId}
                bank_acc_no={props?.accountNumber}
                closeRejectAllTxn={props?.handleClosePopup}
                handleRejectAllTransaction={handleRejectAllTransaction}
                type={props?.type}
                setShowLoader={setShowLoader}
                setSidebarState={setSidebarState}
                setFocus={setFocus}
              />
            </>
          ) : (
            <></>
          )}
        </div>
      </div>
    </div>
  );
};
export default RejectingTransactionPopup;
